<ng-container *ngIf="transport$ | async as transport">
  <div class="modal-header">
    <h4 class="modal-title text-center">{{ 'POPIN_DETAIL_TRANSPORT.TITLE' | translate }}</h4>
    <i aria-label="Close" (click)="handleClick(CLOSE)" class="close pull-right align-middle fas fa-times"> </i>
  </div>
  <jhi-transport-card [transport]="transport"></jhi-transport-card>
  <div class="d-flex align-items-center justify-content-center flex-column mb-2">
    <jhi-bary-button class="btn bary-btn btn-primary" (clickEvent)="handleClick(CLOSE)" [label]="'BTN.CLOSE' | translate"></jhi-bary-button>
  </div>
</ng-container>
